<template>
  <ItemDialog ref="couponVersionWarning" image-type="alert">
    <template #content-area>
      <div class="text-caution">
        <h1>
          <strong>アプリバージョンエラー</strong>
        </h1>
      </div>
      <div class="text-center">
        <p>クーポンを使用する際はアプリを最新にしてください</p>
      </div>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCouponVersionWarning",

  setup() {
    const couponVersionWarning = ref(null);

    const openDialog = () => {
      couponVersionWarning.value.open();
    };

    const closeDialog = () => {
      couponVersionWarning.value.close();
    };

    return {
      couponVersionWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
  font-size: 3vw;
}

.text-caution {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 4vw !important;
}
</style>
